export class ResourceCache {
    private static instance: ResourceCache;

    private cachedCSS: string[] = [];
    private cachedJs: string[] = [];

    static getInstance(): ResourceCache {
        if (!ResourceCache.instance) {
            ResourceCache.instance = new ResourceCache();
        }
        return ResourceCache.instance;
    }

    private constructor() {}

    addJsToCache(src: string) {
        this.cachedJs.push(src);
    }

    addCSSToCache(href: string) {
        this.cachedCSS.push(href);
    }

    checkIfJsLoaded(src: string): Boolean {
        return Boolean(this.cachedJs.find((x) => x === src));
    }

    checkIfCSSLoaded(href: any): Boolean {
        return Boolean(this.cachedCSS.find((x) => x === href));
    }
}
